// extracted by mini-css-extract-plugin
export default {"page":"PinCodeChange_page__kj4q3","content":"PinCodeChange_content__yzz8Z","card":"PinCodeChange_card__i8S5s"};